export const DELAYED_CONTACT_MODAL_MS = 55_000;
export const DELAYED_CONTACT_MODAL_MS = 55_000;
